import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { MasterMessage } from '../../../../masters/masterMessages';
import { Modal } from 'react-responsive-modal';
import ButtonGeneral from '../../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FieldText from '../../../components/general/fields/fieldText';
import {
    asyncPatchAnswer,
    asyncPostAnswer,
} from '../../../../services/survey.service';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import Loading from '../../../components/general/loading/loading';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    saveLoad: (value: boolean) => void;
    idSurvey?: string;
    idQuestion?: string;
    idAnswer?: string;
    answer?: any | undefined;
    loading: false | boolean;
};

const modalValidationReference = ({
    open,
    onClose,
    saveLoad,
    idSurvey,
    idQuestion,
    idAnswer,
    answer,
    loading,
}: Props) => {
    const { range }: any = MasterMessage.surveys;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            referenceField:
                (answer?.description ?? answer?.range ?? '')?.toString() ?? '',
            status: answer?.status !== false,
            question: idQuestion ?? '',
            survey: idSurvey ?? '',
        },
        validationSchema: Yup.object({
            referenceField: Yup.string()
                .trim()
                .required('El campo de base de datos es obligatorio'),
        }),
        onSubmit: async (values) => {
            const payload = {
                question: idQuestion,
                survey: idSurvey,
                description: values.referenceField.trim(),
                status: values.status,
                label: answer?.label ?? '',
                range: answer?.range ?? '',
            };
            if (idAnswer) {
                asyncPatchAnswer(idAnswer, payload)
                    .then((body: any) => {
                        if (body?.items !== undefined) {
                            SwalCustomClass.fire({
                                text: range.messageEdit,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else if (body?.errors !== undefined) {
                            SwalCustomClass.fire({
                                text: range[body.message],
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    })
                    .finally(() => saveLoad(true));
            } else {
                const body: any = await asyncPostAnswer(payload).finally(() =>
                    saveLoad(true)
                );
                if (body?.items !== undefined) {
                    SwalCustomClass.fire({
                        text: range.messageNew,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                    });
                } else if (body?.errors !== undefined) {
                    SwalCustomClass.fire({
                        text: range[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            }
            onClose(false);
        },
    });

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Box>
                        <Typography
                            color="primary"
                            component="h3"
                            sx={{
                                fontSize: { lg: 27, xs: 23 },
                                mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                            }}
                        >
                            Validación por referencia
                        </Typography>
                        <hr />
                        <Box mt={3} px={1}>
                            <Grid
                                container
                                spacing={{ xs: 1, md: 1 }}
                                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                            >
                                <Grid item xs={12} mx={1}>
                                    <FieldText
                                        label="Campo en base de datos a comparar"
                                        name="referenceField"
                                        size="small"
                                        required={true}
                                        touched={formik.touched.referenceField}
                                        errors={formik.errors.referenceField}
                                        value={formik.values.referenceField}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    mt={1}
                                    sx={{ textAlign: 'right' }}
                                >
                                    <ButtonGeneral
                                        onClick={() => formik.handleSubmit()}
                                        startIcon={<Save />}
                                        title="Guardar"
                                        sx={{ mr: 1 }}
                                    />
                                    <ButtonGeneral
                                        onClick={() => onClose(false)}
                                        startIcon={<CancelIcon />}
                                        title="Cerrar"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </>
            )}
        </Modal>
    );
};

export default modalValidationReference;
